import { GzSideMenuWebComponent } from '../../ui/gzSideMenu';
import { PhasrMonitoredRulesGridWebComponent } from '../phasrMonitoredRulesGrid';
import { WEB_COMPONENT_PHASR_MONITORED_RULES, WEB_COMPONENT_PHASR_MONITORED_RULES_GRID } from '../../webcomponents.constants';

export function addCloseSideMenuFunctionality(phasrSidePanel: GzSideMenuWebComponent): void {
  const monitoredRules = document.getElementsByTagName(WEB_COMPONENT_PHASR_MONITORED_RULES);
  const parentElement = monitoredRules[0].shadowRoot?.querySelector(WEB_COMPONENT_PHASR_MONITORED_RULES_GRID) as PhasrMonitoredRulesGridWebComponent;
  const oldCloseSideMenu = phasrSidePanel.closeSideMenu;
  phasrSidePanel.closeSideMenu = (isBack) => {
    if (typeof isBack === 'boolean' && isBack) {
      oldCloseSideMenu.call(phasrSidePanel);
    } else {
      //remove all sidepanels
      const existingSidePanels = parentElement.shadowRoot?.querySelectorAll('.phasr-side-panel');
      existingSidePanels?.forEach((sidePanel) => oldCloseSideMenu.call(sidePanel));
    }
  }
  parentElement.shadowRoot?.appendChild(phasrSidePanel);
}